module.exports = __webpack_public_path__ + "static/media/stock-photo-long-rice-in-a-sack-and-wooden-scoop-isolated-on-white-background-389707480.a7a193c4.jpg";